var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 33,
    fill: "#E0E0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7852 25.1426H42.8209V21.214C42.8209 15.7926 38.4209 11.3926 32.9994 11.3926C27.578 11.3926 23.178 15.7926 23.178 21.214V25.1426H21.2137C19.053 25.1426 17.2852 26.9104 17.2852 29.0711V48.714C17.2852 50.8747 19.053 52.6426 21.2137 52.6426H44.7852C46.9459 52.6426 48.7137 50.8747 48.7137 48.714V29.0711C48.7137 26.9104 46.9459 25.1426 44.7852 25.1426ZM32.9994 42.8211C30.8387 42.8211 29.0709 41.0533 29.0709 38.8926C29.0709 36.7319 30.8387 34.964 32.9994 34.964C35.1602 34.964 36.928 36.7319 36.928 38.8926C36.928 41.0533 35.1602 42.8211 32.9994 42.8211ZM39.0887 25.1426H26.9102V21.214C26.9102 17.8551 29.6405 15.1247 32.9994 15.1247C36.3584 15.1247 39.0887 17.8551 39.0887 21.214V25.1426Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockGroup);
export default __webpack_public_path__ + "static/media/lock-group.6f76b0d1f12f8e3e93b61efc7a5fb348.svg";
export { ForwardRef as ReactComponent };